/** "19 €", "19,50 €" (es) or "€19", "€19.50" (en). Whole amounts drop the decimals. */
export function formatPrice(cents: number, currency: string, locale: "es" | "en"): string {
  const whole = cents % 100 === 0;
  return new Intl.NumberFormat(locale === "en" ? "en-IE" : "es-ES", {
    style: "currency",
    currency: currency.toUpperCase(),
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(cents / 100);
}
